import { combineReducers } from 'redux';
import {listViewReducer } from './listViewReducer'

export default combineReducers({
    listaPublica:listViewReducer,
})